// Returns the two-letter language segment from the current URL's first path
// segment, e.g. "/mk/issuer/..." → "mk".  Returns null when the first segment
// doesn't look like a language code (not 2-5 alpha chars).
export const getLanguageFromUrl = () => {
  const parts = window.location.pathname.split("/").filter(Boolean);
  if (parts.length > 0 && /^[a-z]{2,5}$/i.test(parts[0])) {
    return parts[0].toLowerCase();
  }
  return null;
};

// Resolves the active language code from the Redux language object.
// Falls back to the URL segment when the language object hasn't been
// hydrated yet (only has languageId, no code) — this prevents the
// momentary language flash on first load where withLang() would
// return "mk" and redirect the user away from their current path.
export const getLanguageSegment = (language) => {
  let code = null;

  if (typeof language === "string") {
    code = language;
  }

  if (typeof language === "object" && language !== null) {
    code =
      language.code ||
      language.languageCode ||
      language.culture ||
      language.name ||
      null;
  }

  if (typeof code === "string" && code) {
    return code.split("-")[0].toLowerCase();
  }

  // State hasn't hydrated a language code yet — read from URL to avoid flash.
  return getLanguageFromUrl() || "mk";
};

export const withLang = (state, path = "") => {
  const lang = getLanguageSegment(state?.account?.language);
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  return `/${lang}${cleanPath}`;
};
